import { useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import apiClient from '../api/client'

function ResetPasswordPage(): JSX.Element {
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)
  const token = params.get('token') ?? ''

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)
    if (password.length < 8) {
      setError('Password must be at least 8 characters')
      return
    }
    if (password !== confirm) {
      setError('Passwords do not match')
      return
    }
    setLoading(true)
    try {
      await apiClient.post('/auth/reset-password', { token, new_password: password })
      navigate('/login', { state: { resetDone: true } })
    } catch (err: unknown) {
      let msg = 'Reset failed — link may be invalid or expired'
      const maybeAxios = err as { response?: { data?: { detail?: string } }; message?: string }
      if (maybeAxios?.response?.data?.detail) msg = maybeAxios.response.data.detail
      else if (maybeAxios?.message) msg = maybeAxios.message
      setError(msg)
    } finally {
      setLoading(false)
    }
  }

  if (!token) {
    return (
      <div className="login-page">
        <div className="login-card">
          <h1 className="login-title">BibPipeline</h1>
          <p className="login-subtitle">Invalid reset link</p>
          <p style={{ fontSize: 14 }}>
            This link is missing its token. Please request a new one.
          </p>
          <p style={{ marginTop: 16, fontSize: 14, textAlign: 'center' }}>
            <Link to="/forgot-password">Request new link</Link>
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <h1 className="login-title">BibPipeline</h1>
        <p className="login-subtitle">Choose a new password</p>
        <form className="login-form" onSubmit={handleSubmit}>
          <label className="login-label">
            New password
            <input
              type="password"
              className="login-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={8}
            />
          </label>
          <label className="login-label">
            Confirm password
            <input
              type="password"
              className="login-input"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
            />
          </label>
          {error && <p style={{ color: '#c00', fontSize: 14 }}>{error}</p>}
          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'Saving...' : 'Save new password'}
          </button>
        </form>
        <p style={{ marginTop: 16, fontSize: 14, textAlign: 'center' }}>
          <Link to="/login">Back to sign in</Link>
        </p>
      </div>
    </div>
  )
}

export default ResetPasswordPage
